import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || '';
    const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/admin/login', { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          {},
          {
            headers: { 'X-Session-ID': sessionId },
            withCredentials: true,
          }
        );
        setUser(res.data);
        // Clean URL fragment then navigate
        window.history.replaceState(null, '', '/admin/inquiries');
        navigate('/admin/inquiries', { replace: true, state: { user: res.data } });
      } catch (err) {
        const detail = err?.response?.data?.detail || 'Authentication failed';
        navigate(`/admin/login?error=${encodeURIComponent(detail)}`, { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#0A1128] text-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto border-2 border-white/20 border-t-[#4F6355] rounded-full animate-spin" />
        <div className="mt-6 font-mono text-[11px] tracking-[0.3em] uppercase text-[#94A3B8]">
          Authenticating...
        </div>
      </div>
    </div>
  );
}
